import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-branding',
  template: `
    <div class="branding" style="background-color: white;padding:5px;margin-bottom: 20px;">
      <a href="/dashboard">
        <img
          [src]="brandinglogopath ? brandinglogopath : './assets/images/logos/WealthERP_logo.png'"
          class="align-middle m-2"
          alt="logo"
          [style.width.px]="imageWidth"
          [style.height.px]="imageHeight"
          (load)="onImageLoad($event)"
          style="position: static;padding-bottom: 0px;background-color:white;"
        />
      </a>
    </div>
  `,
})
export class BrandingComponent implements AfterViewInit {
  brandinglogopath: string | null = null;
  imageWidth: number = 220; // Default width
  imageHeight: number = 70; // Default height

  constructor() {
    this.brandinglogopath = sessionStorage.getItem('brandinglogopath');
  }

  ngAfterViewInit(): void {
    this.updateImageDimensions();
  }

  updateImageDimensions(): void {
    const img = new Image();
    img.src = this.brandinglogopath ? this.brandinglogopath : './assets/images/logos/WealthERP_logo.png';
    img.onload = () => {
      this.imageWidth = img.width;
      this.imageHeight = img.height;
    };
  }

  onImageLoad(event: Event): void {
    const img = event.target as HTMLImageElement;
    this.imageWidth = img.naturalWidth;
    this.imageHeight = img.naturalHeight;
  }
}
